// extracted by mini-css-extract-plugin
module.exports = {"userDetailsView":"userDetails_userDetailsView_1yfKL","resendConfirmation":"userDetails_resendConfirmation_3Ncjw","sent":"userDetails_sent_msiZi"};